import React from 'react'
import {Question} from '@styled-icons/bootstrap'
import CircleIcon from '../../primitives/icons/Circle.icon'
import TopbarDropdown from './TopbarDropdown'
import {injectStore} from '../../../store/utils'
import {theme} from '../../styles/theme'
import Link from 'next/link'
import {PAGES_ROUTES} from '../../../configs/routes'
import LangButtons from '../LangButtons/LangButtons'
import {isMobile} from 'src/utils/helpers'
import {Switch} from '../../primitives/Switch/Switch'
import {Store} from '@styled-icons/fa-solid'
import {brand, helpLinkTarget, isAbMode} from 'src/brand'

type TopBarUserProps = {
  //   progress: any,
  avatar: string
  selectedStore: any
  activeCount: number
  isAdmin: boolean
  isCafe24User: boolean
  toggleCustomerView: () => void
  isToggleCustomerView: boolean
}

const TopbarUser: React.FC<TopBarUserProps> = ({
  avatar,
  // progress,
  selectedStore,
  activeCount,
  isAdmin,
  isCafe24User,
  toggleCustomerView,
  isToggleCustomerView,
}) => {
  //   const {valid_widgets} = progress

  return (
    <div className="flex gap-3 items-center">
      {isToggleCustomerView && (
        <div className="flex gap-2 items-center">
          <div className="text-[12px] text-nowrap">Admin</div>
          <Switch id="isAdmin" checked={!isAdmin} onChange={toggleCustomerView} />
          <div className="text-[12px] text-nowrap">Customer</div>
        </div>
      )}
      {isAdmin && isCafe24User && !isMobile && <LangButtons />}
      {isAdmin && !isAbMode && (
        <Link href={PAGES_ROUTES.widgets.list} className="text-[13px] !text-green-600 !no-underline">
          {activeCount} Live Assets
        </Link>
      )}
      {!isMobile && (
        <>
          <div className="d-inline-block flex-shrink-0">
            <a
              className="d-flex items-center rounded-full border-2 border-gray-400 border-solid px-2 text-decoration-none"
              style={{height: 30}}
              rel="noreferrer"
              target="_blank"
              href={selectedStore?.url}
            >
              <Store size={14} color={theme.colors.muted} />
              <span className="ml-2 text-sm text-gray-500" style={{marginTop: 2}}>
                My Store
              </span>
            </a>
          </div>
          <div role="tooltip" aria-label={isAbMode ? 'Contact support' : 'Knowledge center'} data-microtip-position="bottom" className="d-inline-block">
            <a href={brand.helpUrl} target={helpLinkTarget(brand.helpUrl)} rel="noreferrer">
              <CircleIcon color={theme.colors.muted} icon={Question} strokeWidth={3} size={20} />
            </a>
          </div>
        </>
      )}
      <TopbarDropdown image={avatar} />
    </div>
  )
}

export default injectStore(({userStore, widgetStore}) => ({
  //   progress: userStore.progressIndicator,
  avatar: userStore.avatarUrl,
  selectedStore: userStore.selectedStore,
  activeCount: widgetStore.activeCount,
  isAdmin: userStore.isAdmin,
  isCafe24User: userStore.isCafe24User,
  toggleCustomerView: userStore.toggleCustomerView,
  isToggleCustomerView: userStore.isToggleCustomerView,
}))(TopbarUser)
